import {Table, TableProps} from 'antd';
import dayjs from 'dayjs';

import {AdminUser} from '../../../../gen/api/models';

export interface UsersProps {
    users: Array<AdminUser>;
    loading: boolean;
}

export const Users = (props: UsersProps) => {
    const columns: TableProps<AdminUser>['columns'] = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Name',
            dataIndex: 'firstName',
            key: 'name',
            render: (_, user) => `${user.firstName} ${user.lastName}`,
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render: (_, user) => user.role,
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (createdAt) => dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: 'Updated At',
            dataIndex: 'updateAt',
            key: 'updateAt',
            render: (updateAt) => dayjs(updateAt).format('YYYY-MM-DD HH:mm:ss'),
        },
    ];

    return (
        <div>
            <Table<AdminUser>
                rowKey={(record) => record.id}
                columns={columns}
                key={'id'}
                dataSource={props.users}
                loading={props.loading}
                scroll={{x: 'max-content'}}
                pagination={false}
                size={'small'}
            />
        </div>
    );
};
